// Polyfill for requestIdleCallback
        window.requestIdleCallback = window.requestIdleCallback || function(cb) {
          const start = Date.now();
          return setTimeout(function() {
            cb({ 
              didTimeout: false,
              timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - start));
              }
            });
          }, 1);
        };
  
        window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
          clearTimeout(id);
        };
  
        // Handle DeclarativeShadowElement if not defined
        if (typeof window.DeclarativeShadowElement === 'undefined') {
          window.DeclarativeShadowElement = class DummyDeclarativeShadowElement extends HTMLElement {
            constructor() {
              super();
            }
            connectedCallback() {
              // No-op implementation
            }
            disconnectedCallback() {
              // No-op implementation
            }
            attributeChangedCallback() {
              // No-op implementation
            }
          };
          
          // Define the custom element if it doesn't exist
          if (!customElements.get('declarative-shadow-root')) {
            customElements.define('declarative-shadow-root', window.DeclarativeShadowElement, { extends: 'template' });
          }
        }
  
        // Initialize lazySizes with optimized settings
        window.lazySizesConfig = window.lazySizesConfig || {
          loadMode: 1,
          expand: 10,
          expFactor: 1.5,
          loadHidden: false,
          hFac: 0.8
        };
        
        // Optimize INP by breaking up long tasks
        window.optimizeINP = () => new Promise(resolve => setTimeout(resolve, 0));